import React, { useContext, useMemo } from "react";
import {
    Link,
    Navigate,
    Outlet,
    Route,
    Routes,
    useLocation
} from "react-router-dom";
import ForgotPassword from "./components/authenticate/ForgotPassword";
import Login from "./components/authenticate/Login";
import ResetPassword from "./components/authenticate/ResetPassword";
import FullScreenWrapper from "./components/FullscreenWrapper";
import { AuthContext } from "./contexts/AuthContext";
import { ConfigContext } from "./contexts/ConfigContext";
import CreateApp from "./CreateApp";
import BomModelsPage from "./pages/BomModelsPage";
import { CutoutsPage } from "./pages/CutoutsPage";
import Designer from "./pages/Designer";
import ErrorPage from "./pages/ErrorPage";
import HelpCenterPage from "./pages/HelpCenter";
import Landingpage from "./pages/Landingpage";
import ProductionPlan from "./pages/ProductionPlan";
import ProjectFolder from "./pages/ProjectFolder";
import Projects from "./pages/Projects";
import SearchPage from "./pages/SearchPage";
import StatisticsPage from "./pages/StatisticsPage";
import Template from "./pages/Template";
import TemplateCategories from "./pages/TemplateCategories";

const ProtectedRoute = () => {
    const { isLoggedIn } = useContext(AuthContext);
    const location = useLocation();

    if (!isLoggedIn) {
        return <Navigate to="/users/login" replace state={{ from: location }} />
    }

    return (
        <Outlet />
    );
};

const clientRoutes: { [key: string]: JSX.Element } = {
    'default': (
        <Route path="create" key='default' element={<CreateApp />}>
            <Route index element={<Landingpage />} />
            <Route path="new" element={<TemplateCategories />} />
            <Route path="new/:templateID" element={<Template />} />
            <Route path="edit/:projectID?" element={<Designer />} />
            <Route path="projects/:projectId?" element={<Projects />} />
            <Route path="projectfolders/:folderId" element={<ProjectFolder />} />
            <Route path="statistics" element={<StatisticsPage />} />
            <Route path="cutouts" element={<CutoutsPage />} />
            <Route path="bom" element={<BomModelsPage />} />
            <Route path="search" element={<SearchPage />} />
            <Route path="productionplan" element={<ProductionPlan />} />
          
            <Route path="help" element={<HelpCenterPage />} />
        </Route>
    ),
}

const AppRouter: React.FC = () => {
    const { currentClient } = useContext(ConfigContext);


    let routes = useMemo(() => {
        const clientRoute = clientRoutes[currentClient.name.toLowerCase()] ?? clientRoutes['default'];

        return (
            <Routes key={clientRoute.key}>
                <Route errorElement={<ErrorPage />}>
                    <Route path="/users" element={<FullScreenWrapper />}>
                        <Route path="login" element={<Login />} />
                        <Route path="forgotpassword" element={<ForgotPassword />} />
                        <Route path="resetpassword" element={<ResetPassword />} />
                        <Route path="resetconfirmation" element={<><h1>Your password has been reset!</h1><Link to="/">Go to login</Link></>} />
                        <Route path="forgotconfirmation" element={<h1>You will receive an email shortly with a link to reset your password.</h1>} />
                    </Route>
                    <Route element={<ProtectedRoute />}>
                        <Route index element={<Navigate to={{ pathname: "/create" }} />} />
                        {clientRoute}
                    </Route>
                </Route>
            </Routes>);
    }, [currentClient]);

    return routes;
};

export default AppRouter;
